module.exports = __webpack_public_path__ + "static/media/zane.d9f66f3a.jpg";